<template>
    <ButtonCircle @click="toggleGridDisplay" :title="'Grid: ' + (!gridDisplay ? 'show' : 'hide')">
        <i class="icon-grid" :class="gridDisplay ? '' : 'icon-disabled'"></i>
    </ButtonCircle>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "GridDisplay",
        components: {ButtonCircle},
        computed: {
            ...mapState('editor', [
                'gridDisplay',
            ]),

        },

        methods: {
            ...mapMutations('editor', [
                'setSnapToGrid',
                'setGridDisplay',
            ]),

            toggleGridDisplay() {
                let gridDisplay = !this.gridDisplay;

                this.setGridDisplay(gridDisplay);

                if (!gridDisplay) {
                    this.setSnapToGrid(false);
                }
            },

        },
    }
</script>

<style scoped>

</style>